import React from 'react';

import AmazonWebServicesContainer from '@totem/components/administration/amazonWebServices/AmazonWebServicesContainer';
import ServicesContainer from '@totem/components/context/services/servicesContainer';
import AwsCommissioningLayout, {
  AwsCommissioningExtra,
} from '@totem/components/salesOrders/commissioning/AwsCommissioningLayout';
import CommissioningReportContainer from '@totem/components/salesOrders/commissioning/CommissioningReportContainer';
import CommissioningReportLayout, {
  CommissioningReportExtra,
} from '@totem/components/salesOrders/commissioning/CommissioningReportLayout';
import DecommissioningReportContainer from '@totem/components/salesOrders/decommissioning/DecommissioningReportContainer';
import DecommissioningReportLayout, {
  DecommissioningReportExtra,
} from '@totem/components/salesOrders/decommissioning/DecommissioningReportLayout';
import MissingToolMappingsContainer from '@totem/components/salesOrders/missingToolMappings/MissingToolMappingsContainer';
import MissingToolMappingsLayout, {
  MissingToolMappingsExtra,
} from '@totem/components/salesOrders/missingToolMappings/MissingToolMappingsLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const CommissioningReportPage = () => (
  <ContentLayout>
    <ServicesContainer>
      <CommissioningReportContainer>
        <DecommissioningReportContainer>
          <MissingToolMappingsContainer>
            <AmazonWebServicesContainer>
              <IBCard isCovered title="Sales Order Commissioning Report">
                <IBTabs
                  defaultActiveKey="commissioning"
                  items={[
                    {
                      key: 'commissioning',
                      label: <CommissioningReportExtra />,
                      children: <CommissioningReportLayout />,
                    },
                    {
                      key: 'missingToolMappings',
                      label: <MissingToolMappingsExtra />,
                      children: <MissingToolMappingsLayout />,
                    },
                    {
                      key: 'decommissioning',
                      label: <DecommissioningReportExtra />,
                      children: <DecommissioningReportLayout />,
                    },
                    {
                      key: 'aws',
                      label: <AwsCommissioningExtra />,
                      children: <AwsCommissioningLayout />,
                    },
                  ]}
                />
              </IBCard>
            </AmazonWebServicesContainer>
          </MissingToolMappingsContainer>
        </DecommissioningReportContainer>
      </CommissioningReportContainer>
    </ServicesContainer>
  </ContentLayout>
);

export default CommissioningReportPage;
